module.exports = __webpack_public_path__ + "static/media/MW_Logo.dcda4b12.png";